import type { Maybe } from 'src/generated/graph-api';

export const unWrapMaybe = <T>(maybe?: Maybe<T>): T | undefined => {
  if (maybe === null) return undefined;
  return maybe as T | undefined;
};
